import { render, staticRenderFns } from "./inspectable-action-documents-client-or-candidate.vue?vue&type=template&id=578da81d"
import script from "./inspectable-action-documents-client-or-candidate.vue?vue&type=script&lang=js"
export * from "./inspectable-action-documents-client-or-candidate.vue?vue&type=script&lang=js"
import style0 from "./inspectable-action-documents-client-or-candidate.vue?vue&type=style&index=0&id=578da81d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports